import { makeStyles, createStyles } from '@material-ui/core'

export const styles = theme => createStyles({
  label: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,
    color: '#4D505B',
    display: 'inline-block',
    width: '100%',
  },
  alignRight: {
    textAlign: 'right'
  },
  textBold: {
    fontFamily: 'Roboto-Bold'
  },
  subTitle: {
    marginLeft: 20,
  },
  tooltip: {
    fontSize: 12,
  },
  lineWrapper: {
    padding: '12px 16px',
  },
  withBorder: {
    borderBottom: '1px solid #D9DCDF',
  },
  footer: {
    backgroundColor: '#F9F9F9',
  },
});

export default makeStyles(styles)